module.exports = __webpack_public_path__ + "img/page-ico.52fabda0.png";